import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyTotalsOverviewPage } from './daily-totals-overview';
import { MatIconModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    DailyTotalsOverviewPage,
  ],
  imports: [
    IonicPageModule.forChild(DailyTotalsOverviewPage),
    MatIconModule,
    FlexLayoutModule
  ],
})
export class DailyTotalsOverviewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/daily-totals-overview/daily-totals-overview.module.ts